var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaIzquierda22X22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38544 10.7315C9.25303 10.886 9.25303 11.114 9.38544 11.2685L14.2718 16.9692C14.5189 17.2575 14.4856 17.6916 14.1973 17.9387C13.909 18.1858 13.475 18.1524 13.2279 17.8641L8.34146 12.1633C7.76769 11.4939 7.76769 10.5061 8.34146 9.83671L13.2279 4.13591C13.475 3.84763 13.909 3.81424 14.1973 4.06135C14.4856 4.30845 14.5189 4.74247 14.2718 5.03075L9.38544 10.7315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaIzquierda22X22);
export default __webpack_public_path__ + "static/media/FLECHA_IZQUIERDA_22X22.129c00e96b9ea5eb46ed6bf7974f621b.svg";
export { ForwardRef as ReactComponent };